module.exports = __webpack_public_path__ + "static/media/16.d242e611.png";